'use strict'
appUrl = require '../../page/frontend/helpers/app_url'
urlUpdate = require '../../page/frontend/helpers/url_update'
availabilityHelper = require '../../page/helpers/availability'
CardsView = require './views/cards'
CardUI = require 'grpn-card-ui/frontend/init'
DesktopSearch = require './model/search'
DesktopRelated = require './model/related'
errorViewHtml = require './views/error_html'
locationRemembrance = require './location_remembrance'
PaginationFooter = require '../../pagination/frontend/views/footer'
PaginationSeoLinks = require '../../pagination/frontend/helpers/seo_links'
PageHeaderView = require '../../page_header/frontend/views/header'
MapButtonView = require '../../page_header/frontend/views/map_button'
PullMapsApplication = require '../../pull_maps/frontend/application'
RapiDebugView = require 'itier-rapi-debug-client/lib/support/pull/views/debug'
RefinementUI = require 'grpn-refinement-ui/lib/frontend/application'
RefinementUiView = require '../../refinement_ui/frontend/views/refinement_ui'
FeaturedRefinementUiView = require '../../refinement_ui/frontend/views/featured_refinement_ui'
FeaturedRightEndRefinementUiView = require '../../refinement_ui/frontend/views/featured_right_end_refinement_ui'
SortToggle = require '../../../node_modules/grpn-sorts/lib/frontend/application'
spinnerGroup = require '../../page/frontend/helpers/spinner_group'
ViewNoCards = require './views/no_cards'
domConfig = require '../../page/frontend/helpers/dom_config'
hiddenCards = require '../../page/frontend/helpers/initiallyHiddenCards'
WidgetModel = require './model/widget'
WidgetView = require '../../page/frontend/views/bottom_widget'
PlannerView = require './views/planner'
ScrollDepthView = require './views/scroll_depth'
StaticMapView = require '../../pull_maps/frontend/views/static_map'
DynamicMapView = require '../../pull_maps/frontend/views/dynamic_map'
AdsenseAdsView = require '../../adsense_ads/frontend/views/adsense_ads'
{checkSetting, isFeatureEnabled, isInTreatment} = require '../../page/frontend/helpers/finch'
isElementVisible = require '../../page/frontend/helpers/is_element_visible'
isTTDLandingPage = require '../../page/frontend/helpers/is_ttd_landing_page'
SponsoredDealsWidgetModel = require './model/sponsored_deals_widget'
SponsoredDealsWidgetView = require '../../page/frontend/views/sponsored_deals_widget'
{omitUndefined} = require '../../page/helpers/underscore_replacement'
facetsRetriever = require './model/facets'
availabilityRetriever = require './model/availability'
targetedAudienceRetriever = require './model/targetedAudience'
{ windowLoaded } = require '@grpn/document-states'

SELECTORS =
  CARDS_WRAPPER: '#pull-results'
  CARDS: '#pull-cards'
  PAGINATION: '#pull-pagination'
  NOCARDS: '#pull-no-cards'
  CARDSERROR: '#pull-oops-error'
  DEBUG: '#RapiDebugData'
  NOCARDS_MESSAGE: '.notification.info.no-cards'
  NOCARDS_MESSAGE_GETAWAYS: '.getaways_notification'
  REFINEMENT_UI: '#refinement-ui'
  FEATURED_FILTER_TOOLTIPS: '.featured-filter-tooltip'
  FEATURED_REFINEMENT_UI: '#featured-refinement-ui'
  FEATURED_RIGHT_END_REFINEMENT_UI: '#featured-right-end-refinement-ui'
  PAGE_HEADER_TITLE: '#pull-page-header-title'
  CARD_IMAGES: '.cui-c-udc .cui-image'
  FEATURED_CARDS: '.cui-c-udc-featured, .cui-c-udc-featured-fallback'
  EMBEDDED_CARDS: '.cui-c-compound .cui-c-udc'
  WIDGET_VIEW_CONTAINER: '#pull-widget-container'
  WIDGET_VIEW: '#pull-widget'
  STATIC_MAP: '#pull-static-map-container'
  DYNAMIC_MAP_CONTAINER: '.dynamic-map-container'
  ADSENSE_ADS_VIEW: '#pull-ads'
  PLANNER_VIEW: '#planner-widget'
  MAP_BUTTON: '#pull-map-button-container'
  FEATURED_MAP_BUTTON: '#featured-map-button'
  CHANNEL_NAV: 'ls-channel-nav'
  SPONSORED_DEALS_WIDGET_VIEW: '#pull-sponsored-deals-widget'

STICKY =
  HEADER: '#sticky-header'
  REFINEMENT: '#sticky-refinements'

TTD_TARGETED_AUDIENCE_SPLICE = 13

module.exports = _.extend {}, Backbone.Events,
  defaults:
    urlParams: {}
    xhrParams: {}
    xhrBlacklist: []
    spinnerRunning: false

  initialize: ->
    @domConfig = domConfig.get() ? {}
    $(document).ready => @onReady()
    windowLoaded.then( => @onLoad())
    locationRemembrance.initialize('desktop:dealClickedId')

  onLoad: ->
    @_setDefaults()
    @_createApplications()
    @_createModelsAndViews()
    @_addListeners()
    @_handlePageState()
    @_loadAds()
    @_lazyLoadRemainingDeals() unless @hasLoadedDealsWithLocationRememberance

  onReady: ->
    PaginationSeoLinks.set()

  _loadAds: ->
    return unless @domConfig.enabledFeatures?.showLivingSocialAfsAds && @urlParams.query?
    currentPage = if @urlParams.page? then parseInt(@urlParams.page) else 1

    @adsenseAdsView.loadAds(@urlParams.query, currentPage)

  _lazyLoadRemainingDeals: ->
    return unless @lazyLoadingModel
    numOfshellCards = document.querySelectorAll('#pull-cards .cui-shell-card').length
    return unless numOfshellCards

    if @domConfig.appliedFinchSettings?.includes('proactiveCachedAllDealsPage:true')
      @_removeShellCards()
    else
      lazyLoadingOffset = document.querySelectorAll('#pull-cards .card-ui:not(.cui-shell-card):not(.cui-c-udc-featured-fallback
      )').length
      @lazyLoadingModel.fetch(data: _.assign({}, @xhrParams, {lazyLoadingOffset}))

  _truncateElements: ->
    GIG.Utils.truncateElements()

  _setDefaults: ->
    baseParams = Groupon.Utils.unparam()

    @defaults.xhrParams = omitUndefined
      _csrf: @domConfig.csrfToken
      category: baseParams.category
      division: @domConfig.division?.id

    if baseParams?.category?
      @defaults.urlParams.category = baseParams.category

    @_setParams(baseParams)

  _setParams: (params) ->
    @urlParams = _.extend {}, @defaults.urlParams, params
    @xhrParams = _.extend {}, @defaults.xhrParams, params
    @shouldRefreshRefinements = true

    delete @xhrParams[key] for key in @defaults.xhrBlacklist

  _createApplications: ->
    if @domConfig.enabledFeatures?.refinementUI
      domConfigData = @domConfig.RefinementUI

      options =
        container: SELECTORS.REFINEMENT_UI
        rightEndContainer: SELECTORS.FEATURED_RIGHT_END_REFINEMENT_UI
        featuredContainer: SELECTORS.FEATURED_REFINEMENT_UI
        showAllFiltersToggle: @domConfig.enabledFeatures?.showToggleAllFilters
        initialFilterHide: @domConfig.enabledFeatures?.showToggleAllFilters

      if @domConfig.enabledFeatures.lazyLoadDesktopFilters
        @_getRefinements(@domConfig.csrfToken, options)
      else
        @refinementUIApp = new RefinementUI domConfigData.PageData, options
    @mapsApp = PullMapsApplication.initialize(this)

    @_initCardUI()

  _initCardUI: ->
    CardUI.init('#pull-cards')
    @_adjustOrphanDealOnDesktop()

  _loadRefinementUi: (data, options) ->
    @refinementUIApp = new RefinementUI data.refinementUI.widgets, options
    @refinementUiView = new RefinementUiView el: SELECTORS.REFINEMENT_UI
    @featuredRefinementUiView = new FeaturedRefinementUiView el: SELECTORS.FEATURED_REFINEMENT_UI
    @featuredRightEndRefinementUiView = new FeaturedRightEndRefinementUiView el: SELECTORS.FEATURED_RIGHT_END_REFINEMENT_UI
    @listenTo @refinementUIApp.events, 'refinementsUpdated', (refData, id, isReset) ->
      @_clearNoCardsMessage()
      @_onUpdate(refData, true, isReset)
      @_featuredMapToggle() if id is 'map'

  _getRefinements: (csrf, options, attempts = 1) ->
    facetsRetriever.getFacets(csrf).then(
      (data) =>
        @_loadRefinementUi(data, options)
      (err) =>
        if attempts <= 1
          @_getRefinements(csrf, options, attempts + 1)
    )

  _createModelsAndViews: ->
    @searchModel = new DesktopSearch()
    @relatedModel = new DesktopRelated()
    @preloadedNextPageModel = new DesktopSearch()
    @lazyLoadingModel = new DesktopSearch() if @domConfig.enabledFeatures?.lazyLoadingBrowseSearchPages
    @cardsView = new CardsView el: SELECTORS.CARDS
    @noCardsView = new ViewNoCards el: SELECTORS.NOCARDS
    @paginationView = new PaginationFooter
      el: SELECTORS.PAGINATION
    @pageHeaderView = new PageHeaderView el: SELECTORS.PAGE_HEADER_TITLE
    @debugView = new RapiDebugView el: SELECTORS.DEBUG
    SortToggle.initialize()
    unless @domConfig.lazyLoadDesktopFilters
      @refinementUiView = new RefinementUiView el: SELECTORS.REFINEMENT_UI
      @featuredRefinementUiView = new FeaturedRefinementUiView el: SELECTORS.FEATURED_REFINEMENT_UI
      @featuredRightEndRefinementUiView = new FeaturedRightEndRefinementUiView el: SELECTORS.FEATURED_RIGHT_END_REFINEMENT_UI
    @staticMapView = new StaticMapView el: SELECTORS.STATIC_MAP
    @dynamicMapView = new DynamicMapView el: SELECTORS.DYNAMIC_MAP_CONTAINER
    @adsenseAdsView = new AdsenseAdsView el: SELECTORS.ADSENSE_ADS_VIEW
    @mapButtonView = new MapButtonView el: SELECTORS.MAP_BUTTON if @domConfig.enabledFeatures?.showDesktopFilters
    @scrollDepthView = new ScrollDepthView()

    @_setupBottomWidget() unless (@domConfig.enabledFeatures?.isTTDPage and checkSetting('showPlanAheadWidget'))
    @_setupSponsoredDealsWidget() unless @domConfig.appliedFinchSettings?.includes('proactiveCachedAllDealsPage:true')
    @_setupLazyloadedDealsWithLocationRememberance()

  _setupLazyloadedDealsWithLocationRememberance: ->
    return unless @lazyLoadingModel
    return unless window.history.state
    {selectedDealBhc, sanitizedCardsHtml} = window.history.state
    return unless !!sanitizedCardsHtml
    document.querySelector(SELECTORS.CARDS).innerHTML = sanitizedCardsHtml
    deal = document.querySelector(".card-ui[data-bhc='" + selectedDealBhc + "']")
    deal?.scrollIntoView()
    @_fetchTargetedAudience() if @domConfig.enabledFeatures?.lazyLoadingBrowseSearchPages
    @_initCardUI()
    @hasLoadedDealsWithLocationRememberance = true

  _setupBottomWidget: ->
    @widgetModel = new WidgetModel()
    @bottomWidgetView = new WidgetView
      el: SELECTORS.WIDGET_VIEW
      model: @widgetModel
      _csrf: @domConfig.csrfToken

  _setupSponsoredDealsWidget: ->
    @sponsoredDealsWidgetModel = new SponsoredDealsWidgetModel()
    @sponsoredDealsWidgetView = new SponsoredDealsWidgetView
      el: SELECTORS.SPONSORED_DEALS_WIDGET_VIEW
      model: @sponsoredDealsWidgetModel
      _csrf: @domConfig.csrfToken

  _setupPlannerWidget: (response) ->
    formattedDates = availabilityHelper.getFormattedAvailability(response.availability)

    @plannerView = new PlannerView
      el: SELECTORS.PLANNER_VIEW
      _csrf: @domConfig.csrfToken
      availabilityData: formattedDates

  _onResize: ->
    @_truncateElements()
    @mapsApp?.reCenterDynamicMap()

  _hackCheckIfNextPageExists: ->
    document.querySelector('#pull-pagination')?.style.display != 'none' && document.querySelector('#pull-pagination a.next[href]') != null

  _addPreloadNextPageScrollListener: ->
    @_handlePreloadingDeals = =>
      if window.scrollY / document.body.scrollHeight > .35
        if @_hackCheckIfNextPageExists()
          @preloadedNextPageNum = if @xhrParams.page? then (Number.parseInt(@xhrParams.page) + 1).toString() else '2'
          @preloadedNextPageModel.fetch(data: _.assign({}, @xhrParams, {page: @preloadedNextPageNum}))
        window.removeEventListener('scroll', @_onScroll)

    @_onScroll = _.debounce(@_handlePreloadingDeals, 250)
    window.addEventListener('scroll', @_onScroll)

  _addPlannerScrollListener: ->
    return unless isTTDLandingPage()

    cardContainer = document.querySelector(SELECTORS.PLANNER_VIEW)

    if isElementVisible(cardContainer)
      @_fetchAvailability()
      isFeatureEnabled('showPlanAheadWidget')
    else
      @_handlePlannerWidgetBucketing = =>
        if isElementVisible(cardContainer)
          @_fetchAvailability()
          isFeatureEnabled('showPlanAheadWidget')
          window.removeEventListener('scroll', @_handlePlannerWidgetBucketingDebounce)

      @_handlePlannerWidgetBucketingDebounce = _.debounce(@_handlePlannerWidgetBucketing, 200)
      window.addEventListener('scroll', @_handlePlannerWidgetBucketingDebounce)

  _addCardOnMouseDownListener: (cardsHtml) ->
    (card) ->
      card.classList.add('has-location-rememberance-listener')
      card.addEventListener 'mousedown', (event) ->
        if cardsHtml?.length
          sanitizedCardsHtml = cardsHtml.replace(/has-scroll-listener|has-viewportenter-listener|has-location-rememberance-listener/g, '')
          selectedDealBhc = this?.dataset?.bhc
          window.history?.replaceState?({sanitizedCardsHtml, selectedDealBhc}, null, window.location.href)

  _addListeners: ->
    $(window).resize => _.debounce(@_onResize(), 200)

    if @_removeLHNEnabled()
      @_toggleStickyHeader()

    @lastClickedDeal = locationRemembrance.getLastDealId()

    if @lastClickedDeal and @_canShowRelatedDeals()
      @listenTo @relatedModel, 'sync', @_onRelatedSync
      @_updateRelated()

    if @preloadedNextPageModel
      @_addPreloadNextPageScrollListener()
      @listenTo @preloadedNextPageModel, 'sync', @_onPreloadedNextPageModelSync

    if @lazyLoadingModel
      @listenTo @lazyLoadingModel, 'sync', @_onLazyLoadingModelSync

    @_addPlannerScrollListener()

    @listenTo @searchModel, 'request', @_startSpinner
    @listenTo @searchModel, 'sync', @_onSearchSync
    @listenTo @searchModel, 'error', @_onSearchError
    @listenTo @paginationView, 'click:paginationLink', @_onPaginationClick
    @listenTo @noCardsView, 'reset', @_reset
    @listenTo @noCardsView, 'calendarReset', @_calendarReset

    if @mapsApp
      @listenTo @mapsApp.map, 'click:toggle', @_onMapToggleButtonClick

    @listenTo SortToggle, 'change:sort', (sortData) =>
      if @refinementUIApp?.selectedRefinements
        data = _.extend {}, @refinementUIApp.selectedRefinements, sortData
      else
        data = sortData

      @_onUpdate(data, false)

    if @refinementUIApp?
      @listenTo @refinementUIApp.events, 'refinementsUpdated', (refData, id, isReset) ->
        @_clearNoCardsMessage()
        @_onUpdate(refData, true, isReset)
        @_featuredMapToggle() if id is 'map'

    window.onpopstate = => @_onPopState()

  _fetchTargetedAudience: (attempts = 1) ->
    return unless @domConfig.enabledFeatures?.isTTDPage
    return unless checkSetting('showTargetedAudienceOccasions')

    csrf = @domConfig.csrfToken
    targetedAudienceRetriever.getTargetedAudience(csrf).then(
      (response) ->
        allCards = document.querySelectorAll('#pull-cards > .card-ui')
        splicer = allCards[TTD_TARGETED_AUDIENCE_SPLICE]
        targetedHtml = response.targetedAudienceOccasionsHtml
        splicer.insertAdjacentHTML('afterend', targetedHtml)
        CardUI.init()
      (err) ->
        if attempts <= 1
          @_fetchTargetedAudience(attempts + 1)
    )

  _fetchAvailability: (attempts = 1) ->
    return unless @domConfig.enabledFeatures?.isTTDPage
    csrf = @domConfig.csrfToken
    availabilityRetriever.getAvailability(csrf).then(
      (response) =>
        @_setupPlannerWidget(response)
      (err) ->
        if attempts <= 1
          @_fetchAvailability(attempts + 1)
    )

  _toggleStickyHeader: ->
    headerOffset = $(SELECTORS.FEATURED_REFINEMENT_UI).offset().top - 16
    @_stickyHeader = ->
      if window.pageYOffset >= headerOffset
        $(SELECTORS.PAGE_HEADER_TITLE).hide()
        $(STICKY.HEADER).addClass('f-ref-ui-sticky').removeClass('row')
        $(SELECTORS.FEATURED_FILTER_TOOLTIPS).addClass('tooltip-offset')
        $(STICKY.REFINEMENT).addClass('header-column')
        $(STICKY.REFINEMENT).addClass('interior-tooltip')
      else
        headerOffset = $(SELECTORS.FEATURED_REFINEMENT_UI).offset().top - 16
        $(STICKY.HEADER).removeClass('f-ref-ui-sticky').addClass('row')
        $(STICKY.REFINEMENT).removeClass('header-column')
        $(STICKY.REFINEMENT).removeClass('interior-tooltip')
        $(SELECTORS.PAGE_HEADER_TITLE).appendTo('#pull-page-header')
        $(SELECTORS.PAGE_HEADER_TITLE).show()

    window.addEventListener('scroll', @_stickyHeader)

  _onMapToggleButtonClick: ->
    @_onUpdate(@refinementUIApp.selectedRefinements, false) if @refinementUIApp.selectedRefinements.map?

  _onPopState: ->
    newParams = Groupon.Utils.unparam()
    # Some browsers (like Safari) will fire an initial popstate event
    # on page load, and we don't want to fire off searches etc
    # in that case (or anytime params haven't updated)
    return if _.isEqual(newParams, @urlParams)

    @_updateParams(newParams)
    @_updateSearch()
    @_updatePageTracking()

  _onRelatedSync: ->
    @_renderRelatedDeals @relatedModel.toJSON()

  _renderRelatedDeals: (relatedModel) ->
    {relatedDealsHtml} = relatedModel

    return unless relatedDealsHtml and @clickedDealCard
    cardsPerColumn = if @_removeLHNEnabled() then 3 else 2

    visibleNotFeaturedCards = @_getVisibleNotFeatured()
    clickedDealIndex = visibleNotFeaturedCards.index(@clickedDealCard)

    return unless clickedDealIndex > -1

    if isInTreatment('TTD_YMALForDealViews_Q218_1', 'Treatment')
      rowIndex = clickedDealIndex + (cardsPerColumn - clickedDealIndex % cardsPerColumn)
      insertAfter = visibleNotFeaturedCards[rowIndex - 1]
      $(insertAfter).attr('data-pointer', clickedDealIndex % cardsPerColumn)
      @cardsView.insertAfter relatedDealsHtml, $(insertAfter)

    if isFeatureEnabled('TTDshowYMALCarousel')
      CardUI.init()

  _handlePageState: ->
    if $(SELECTORS.NOCARDS).data('noResults') and $(SELECTORS.NOCARDS_MESSAGE_GETAWAYS).length == 0
      if @urlParams.query
        @defaults.xhrBlacklist.push 'query'
        @_performAllDealsSearch()
      else if @urlParams.maxPrice or @urlParams.minPrice
        @_performPriceSanitizerSearch()

  _startSpinner: ->
    spinnerGroup.start 'search',
      el: SELECTORS.CARDS_WRAPPER
    @spinnerRunning = true

  _stopSpinner: ->
    GIG.Utils.truncateElements($(SELECTORS.CARDS), { watch: false })
    return unless @spinnerRunning

    spinnerGroup.stop 'search'
    @spinnerRunning = false

  _renderModel: (pageModel) ->
    {cardsHtml, noCardsHtml, pageHeaderTitleHash, sortToggleHash} = pageModel

    @_updateTitles(pageHeaderTitleHash)

    @_resetSortToggleView(sortToggleHash)

    if _.isEmpty(cardsHtml) and _.isEmpty(noCardsHtml)
      @_onSearchError()
    else if noCardsHtml
      @_updateNoCards noCardsHtml
    else if cardsHtml
      @_onCardsHtmlUpdateCards(pageModel)

    if @preloadedNextPageModel
      @preloadedNextPageNum = null
      @preloadedNextPageModelJSON = null
      window.addEventListener('scroll', @_onScroll)

  _onSearchSync: ->
    @_renderModel(@searchModel.toJSON())

  _onPreloadedNextPageModelSync: ->
    @preloadedNextPageModelJSON = @preloadedNextPageModel.toJSON()

  _removeShellCards: ->
    shellCards = document.querySelectorAll('#pull-cards .cui-shell-card')
    for card in shellCards
      card.remove()

  _onLazyLoadingModelSync: ->
    @lazyLoadingModelJSON = @lazyLoadingModel.toJSON()
    {cardsHtml} = @lazyLoadingModelJSON

    @_removeShellCards()

    if cardsHtml
      @cardsView.append cardsHtml
      @_adjustOrphanDealOnDesktop()
      @_fetchTargetedAudience()
      @_initCardUI()

      allCards = document.querySelectorAll('.card-ui:not(.has-location-rememberance-listener)')
      cardsHtml = document.querySelector('#pull-cards')?.innerHTML
      allCards.forEach(@_addCardOnMouseDownListener(cardsHtml)) if allCards.length

      window.Groupon.DFPAds.load() if window.Groupon?.DFPAds?.load?

  _noCardsMessageIsDisplayed: (searchResults) ->
    $(SELECTORS.NOCARDS_MESSAGE).length and
    searchResults.refinementUIHash?.shouldDisplay

  _refinementUIAppHasMismatch: (searchResults) ->
    return true if not searchResults.refinementUIHash?.refinementUI?.shouldDisplay
    !!@refinementUIApp?.hasMismatch(searchResults.refinementUIHash?.refinementUI.widgets)

  _clearNoCardsMessage: ->
    $(SELECTORS.NOCARDS).empty()

  _onCardsHtmlUpdateCards: (searchResults) ->
    if (@_noCardsMessageIsDisplayed(searchResults)) or
    @_refinementUIAppHasMismatch(searchResults)
      @_resetView searchResults.refinementUIHash
    @_updateCards searchResults
    @_fetchTargetedAudience()

  _updateTitles: (pageHeaderTitleHash) ->
    return unless pageHeaderTitleHash
    @pageHeaderView.render pageHeaderTitleHash
    document.title = pageHeaderTitleHash.pageTitle

  _resetView: (refinementUIHash) ->
    @_filterToggleOptionShown = @refinementUIApp?.$toggleAllFilters?.attr('data-option-shown')

    @refinementUIApp?.removeAllFeaturedFilters()
    @refinementUiView.render refinementUIHash?.refinementUI
    @featuredRefinementUiView.render refinementUIHash?.refinementUI?.featuredHtml
    @featuredRightEndRefinementUiView.render refinementUIHash?.refinementUI?.rightEndHtml
    widgets = refinementUIHash?.refinementUI?.widgets
    options = refinementUIHash?.refinementUI?.options

    map = _.find widgets, (widget) ->
      widget.id == 'map'

    map?.isActive = @mapsApp?.isDynamic

    @refinementUIApp = new RefinementUI widgets,
      container: SELECTORS.REFINEMENT_UI
      featuredContainer: SELECTORS.FEATURED_REFINEMENT_UI
      rightEndContainer: SELECTORS.FEATURED_RIGHT_END_REFINEMENT_UI
      showAllFiltersToggle: options?.showAllFiltersToggle
      initialFilterHide: @_filterToggleOptionShown ? false

    @listenTo @refinementUIApp.events, 'refinementsUpdated', (refData, id, isReset) ->
      @_clearNoCardsMessage()
      @_onUpdate(refData, true, isReset)
      @_featuredMapToggle() if id is 'map'

  _updateCards: (searchResults) ->
    {cardsHtml, refinementUIHash, paginationHash, rapiDebug, aiAdsHash, map} = searchResults

    @cardsView.render cardsHtml, aiAdsHash
    @_adjustOrphanDealOnDesktop()

    if @lazyLoadingModel
      allCards = document.querySelectorAll('.card-ui:not(.has-location-rememberance-listener)')
      cardsHtml = document.querySelector('#pull-cards')?.innerHTML

      allCards.forEach(@_addCardOnMouseDownListener(cardsHtml)) if allCards.length

    if $(SELECTORS.NOCARDS).data('noResults') and $(SELECTORS.NOCARDS_MESSAGE_GETAWAYS).length == 0
      @_showCardsAndNoCards()
    else
      @_showCards()

    @paginationView.render presentedHash: paginationHash
    if @shouldRefreshRefinements
      @refinementUIApp?.updateRefinements(refinementUIHash?.refinementUI?.widgets ? [])
    else
      @shouldRefreshRefinements = true
    @debugView.render rapiDebug

    @_initCardUI()
    # https://jira.groupondev.com/browse/ION-7882
    _.delay (=> @_forceImageToLoad()), 1000

    @_updateMap(map) if map?
    @_stopSpinner()
    PaginationSeoLinks.set()

  _updateNoCards: (noCardsHtml) ->
    @noCardsView.render noCardsHtml
    $(SELECTORS.NOCARDS).data('noResults': true)
    @_showNoCards()
    @_performPriceSanitizerSearch()

  _performPriceSanitizerSearch: ->
    if @_sanitizePriceUrl() is false
      return @_performAllDealsSearch()
    @_updateSearch()
    @_updatePageTracking()

  _updateMap: (map) ->
    if !@mapsApp?
      $(SELECTORS.FEATURED_MAP_BUTTON).remove() if !map.show and @_removeLHNEnabled()
      @staticMapView.render map unless @_removeLHNEnabled()
      @dynamicMapView.render map
      @mapButtonView.render map if @mapButtonView
      @mapsApp = PullMapsApplication.initialize(this)
      if @mapsApp
        @listenTo @mapsApp.map, 'click:toggle', @_onMapToggleButtonClick
    else if !map.show
      $(SELECTORS.STATIC_MAP).empty()
      $(SELECTORS.DYNAMIC_MAP_CONTAINER).empty()
      $(SELECTORS.MAP_BUTTON).empty()
      $(SELECTORS.FEATURED_MAP_BUTTON).remove()
      @stopListening @mapsApp.map
      @mapsApp = null

  _canShowRelatedDeals: ->
    @domConfig.enabledFeatures?.showYMALCarousel ? false

  _removeLHNEnabled: ->
    @domConfig.enabledFeatures?.removeLeftHandNav ? false

  _scrollToTopOnRefine: ->
    if @domConfig.RefinementUI.ScrollToTopOnRefine
      $(document).scrollTop(0)

  _sanitizePriceUrl: ->
    return false unless @xhrParams.minPrice or @xhrParams.maxPrice or @urlParams.minPrice or @urlParams.maxPrice
    @urlParams = _.omit @urlParams, 'minPrice', 'maxPrice'
    @xhrParams = _.omit @xhrParams, 'minPrice', 'maxPrice'
    @_updateUrl()

  _onSearchError: ->
    return if @fetchXhr?.statusText is 'abort'
    $(SELECTORS.CARDSERROR).html errorViewHtml.render()
    @_showError()
    @_stopSpinner()
    @_sanitizePriceUrl()

  _showCardsAndNoCards: ->
    $(SELECTORS.CARDS).show()
    $(SELECTORS.NOCARDS).show()
    $(SELECTORS.PAGINATION).show()
    $(SELECTORS.CARDSERROR).hide()

  _showCards: ->
    $(SELECTORS.CARDS).show()
    $(SELECTORS.PAGINATION).show()
    $(SELECTORS.CARDSERROR).hide()
    $(SELECTORS.NOCARDS).hide()

  _showNoCards: ->
    $(SELECTORS.NOCARDS).show()
    $(SELECTORS.CARDS).hide()
    $(SELECTORS.PAGINATION).hide()
    $(SELECTORS.CARDSERROR).hide()

  _showError: ->
    $(SELECTORS.CARDSERROR).show()
    $(SELECTORS.CARDS).hide()
    $(SELECTORS.PAGINATION).hide()
    $(SELECTORS.NOCARDS).hide()

  _addFeaturedFiltersParam: (newUrlParams, isReset) ->
    featured_filters = []
    if not isReset
      if @urlParams.featured_filters?
        featured_filters = @urlParams.featured_filters.split(',')

      if newUrlParams.seasons?
        featured_filters.push('seasons')

      if newUrlParams.groups?
        featured_filters.push('groups')
      featured_filters = _.chain(featured_filters).compact().uniq().value()

    featured_filters = featured_filters.join(',')

  _featuredMapToggle: ->
    @mapsApp?.toggle()

  _onUpdate: (selectedRefinements, isRefinementUpdated, isReset = false) ->
    newUrlParams = appUrl.updateParams(selectedRefinements, isRefinementUpdated)
    featured_filters = @_addFeaturedFiltersParam(newUrlParams, isReset)
    newUrlParams.featured_filters = featured_filters if featured_filters?.length

    omitUndefined newUrlParams

    @_updateParams(newUrlParams)
    @_updateUrl()
    @mapsApp?.onRefine()
    @_scrollToTopOnRefine()
    @_updateSearch()
    @_updatePageTracking()
    @_updatePlannerWidget() if @domConfig.enabledFeatures?.isTTDPage
    locationRemembrance.addDealClickHandler()

  _isCachedPageMatchingNextRequest: ->
    @preloadedNextPageNum == @xhrParams.page and @preloadedNextPageModelJSON?

  _renderNextPage: ->
    if not @_isCachedPageMatchingNextRequest()
      return @_updateSearch()

    @_renderModel(@preloadedNextPageModelJSON)

  _setNoResultsDataToFalse: ->
    $(SELECTORS.NOCARDS).data('noResults': false)

  _getUrlParams: (href) ->
    Groupon.Utils.unparam(href.split("?")[1] ? '')

  _getVisibleNotFeatured: ->
    $(SELECTORS.CARDS).find(".cui-c-udc:not(#{SELECTORS.FEATURED_CARDS}):not(#{SELECTORS.EMBEDDED_CARDS})")

  _scrollToTop: ->
    $(document).scrollTop(0)

  _onPaginationClick: (event) ->
    @_setNoResultsDataToFalse()
    newUrlParams = @_getUrlParams(event.currentTarget.href)
    @_updateParams(newUrlParams)
    @_updateUrl({ pushState: true })
    @_scrollToTop()
    @_renderNextPage()
    @shouldRefreshRefinements = false
    @_loadAds()

  _performAllDealsSearch: ->
    @_updateParams()
    @_updateSearch()
    @_updatePageTracking()

  _updatePageTracking: ->
    OptimizeSuite.treatAsNewPage(window.location.href)

  _updateParams: (newUrlParams = {}) ->
    return if _.isEqual(newUrlParams, @urlParams)
    @_setParams(newUrlParams)
    @urlParams = _.chain(@urlParams).omit((value) -> !value).value()

  _updateSearch: ->
    @fetchXhr.abort() if @fetchXhr?.readyState in [1..3]
    @fetchXhr = @searchModel.fetch(data: @xhrParams)
    if @mapsApp?.isDynamic
      @mapsApp?.update(@xhrParams)
    else
      @mapsApp?.markUpdated()

  _updateRelated: ->
    return unless @lastClickedDeal
    return unless @clickedDealCard = @_getVisibleNotFeatured()?.filter(".cui-c-udc[data-bhc='" + @lastClickedDeal + "']")
    return if @clickedDealCard.hasClass('is-clo')

    @relatedModel.fetch
      data:
        _csrf: @domConfig.csrfToken
        currentDeal: @lastClickedDeal.replace('deal:', '')

  _updatePlannerWidget: ->
    @plannerView?.load() if checkSetting('showPlanAheadWidget')

  _updateUrl: (opts = {}) ->
    paramString = $.param @urlParams
    updatedUrl = window.location.pathname

    if paramString.length
      updatedUrl += "?#{paramString}"

    urlUpdate.update(updatedUrl, opts)

  _reloadPage: ->
    window.location.reload()

  _reset: ->
    if !!@refinementUIApp?.bookableModel
      @refinementUIApp.resetAll()
    else
      @_reloadPage()

  _calendarReset: ->
    @refinementUIApp.calendarReset()

  _forceImageToLoad: ->
    return unless firstImage = $(SELECTORS.CARD_IMAGES)[0]
    return unless firstImage.getAttribute('src').lastIndexOf('data:', 0) is 0
    @_initCardUI()

  _adjustOrphanDealOnDesktop: ->
    hiddenCards.adjustOrphanDeal()
    $('.cui-c-udc.cui-udc-hidden .cui-image').trigger('appear')

  _resetSortToggleView: (sortToggleHash = {}) ->
    SortToggle?.sortToggleView?.resetView?(sortToggleHash)
